import { Chart } from '@frontend/chart/types';

export const IOTS_UPTIME_BY_TYPE_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'server', data: [{ label: 'full_period', value: 99 }] },
        { name: 'android', data: [{ label: 'full_period', value: 97 }] },
        { name: 'access_controller', data: [{ label: 'full_period', value: 95 }] },
        { name: 'payment_terminal', data: [{ label: 'full_period', value: 92 }] },
        { name: 'printer', data: [{ label: 'full_period', value: 88 }] },
        { name: 'mobile', data: [{ label: 'full_period', value: 84 }] }
    ]
};
